import classnames from 'classnames';
export const getClassName = props => {
    const { disabled, error, labelNumber, textAlign, hidebottomline, className, title, children, prefixCls = 'im-input', prefixListCls = 'im-inputitem', isTitleUp, isSearch, extra, } = props;
    const wrapCls = classnames(`${prefixListCls}-item`, `${prefixCls}-item`, `${prefixListCls}-item-middle`, className, {
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-error`]: error,
        [`${prefixCls}-focus`]: focus,
        [`${prefixCls}-android`]: focus,
    });
    const labelCls = classnames(`${prefixCls}-label`, {
        [`${prefixCls}-label-up`]: isTitleUp,
    });
    const titleWrap = classnames({ [`${prefixCls}-titleWrap`]: isTitleUp });
    const controlCls = classnames(`${prefixCls}-control`, {
        [`${prefixCls}-control-right`]: textAlign === 'right',
        [`${prefixCls}-control-center`]: textAlign === 'center',
        [`${prefixCls}-control-notitle`]: !title && !children,
        [`${prefixCls}-control-isTitleUp`]: isTitleUp && extra,
        [`${prefixCls}-control-extra`]: !isTitleUp && extra,
    });
    const lineCls = classnames(`${prefixListCls}-line`, {
        [`${prefixListCls}-line-hidebottomline`]: hidebottomline,
        [`${prefixListCls}-isTitleUp`]: isTitleUp,
    });
    const clearCls = classnames(`${prefixCls}-clear`, {});
    const errorCls = classnames({
        [`${prefixCls}-error-isTitleUp`]: isTitleUp || isSearch,
    });
    return {
        wrapCls,
        labelCls,
        titleWrap,
        controlCls,
        lineCls,
        clearCls,
        errorCls,
    };
};
export const calcPos = (prePos, preCtrlVal, rawVal, ctrlVal, placeholderChars, maskReg) => {
    const editLength = rawVal.length - preCtrlVal.length;
    const isAddition = editLength > 0;
    let pos = prePos;
    if (isAddition) {
        const additionStr = rawVal.substr(pos - editLength, editLength);
        let ctrlCharCount = additionStr.replace(maskReg, '').length;
        pos -= editLength - ctrlCharCount;
        let placeholderCharCount = 0;
        while (ctrlCharCount > 0) {
            if (placeholderChars.indexOf(ctrlVal.charAt(pos - ctrlCharCount + placeholderCharCount)) === -1) {
                ctrlCharCount--;
            }
            else {
                placeholderCharCount++;
            }
        }
        pos += placeholderCharCount;
    }
    return pos;
};
export const normalizeValue = (value) => {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return `${value}`;
};
